import React from 'react';
import './SiteFooter.css';

const SiteFooter = () => (
  <footer className="site-footer">
    <div className="site-footer__inner">
      <h5 className="site-footer__logo">ASIAN TOUR</h5>
      <nav className="site-footer__nav">
        <a href="/self-booking">Найти тур</a>
        <a href="/hot-tours">Горящие туры</a>
        <a href="/book">Бронируйте с нами</a>
        <a href="/why">Почему мы</a>
        <a href="/contact">Контакты</a>
      </nav>
    </div>
    <div className="site-footer__bottom">
      <p>© 2025 Все права защищены | AsianTour</p>
      <div className="policy-links">
        <a href="/">Сайт компании</a>
        <span>|</span>
        <a href="#privacy-policy">Политика конфиденциальности</a>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
